import { FilterContext } from '@ecosystem/newron-client-lib';

export const filterContext: FilterContext = { product: 'newron', namespace: 'market-portfolio' };
